<canvas id="canvas" #canvasConfetti></canvas>
